if (!customElements.get('fff-best-sellers')) {
  customElements.define('fff-best-sellers', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fff-bestsellers__track');
      this.controls = this.querySelector('.fff-bestsellers__controls');
      if (!this.track || !this.controls) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 2;
        this.controls.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 2;
        this.controls.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft >= max - 2;
      };
      this.controls.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const card = this.track.querySelector('li');
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
      this.track.addEventListener('scroll', this.update, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
